import React from 'react';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory';
import { convertModuleByGuid, toCallSi } from "./SgiCompComm";
import { addCtnCommonAttribute } from "./SgiCtnComm";
import { SgiModal } from './SgiModal';
import { getFunctionByKey } from './sgiBaseComp/SgiCommon';

class SgiMainComp extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			loaded: false,
			mainUIProps: { style: { width: '100%' } },
			mainUIItems: [],
			modalItems: [],
			modalInstanceItems: []
		};

		let { objFct, type } = this.props;

		if (type !== 'dnd' && this.props.type != "dnd-nest") {
			// 事件集解析
			if (this.props.moduleDesc && this.props.moduleDesc.funs) {
				let funs = this.props.moduleDesc.funs;
				let reg = new RegExp(/console/gi);
				funs = funs.replace(reg, "tool.sgiLogger");
				try {
					let $funs = new Function("module", "objFct", funs);
					funs = $funs(this, objFct);
					if (objFct) {
						let oFuns = objFct.get("@funs");
						if (!oFuns) {
							oFuns = {};
							objFct.set("@funs", oFuns);
						}
						Object.assign(oFuns, funs);
					}
				} catch (error) {
					sgiLogger.error("事件集解析出错，请检查组件自定义事件集书写是否正确！");
					sgiLogger.eventErr(error);
				}
			}

			// 事件集对象解析
			if (this.props.moduleDesc && this.props.moduleDesc.funObj) {
				let moduleDesc = this.props.moduleDesc;
				// sgiLogger.time("事件集对象解析");
				let funObj = moduleDesc.funObj;
				let cnsts = funObj.cnsts;//常量
				let attrs = funObj.attrs;//属性
				let events = funObj.events;//事件
				let cnstObj;
				let retFlg = false, cnstFlg = false;
				const belongUID = `[${moduleDesc.n || moduleDesc.te}][${moduleDesc.guid}]`;
				let funStr = ``;
				if (cnsts && cnsts.length > 0) {
					funStr += `${cnsts.map(c => "const " + c.cnstKey + " = " + (c.cnstVal || "undefined") + ";\n").join("")}`
					cnstFlg = true;
					// 常量存储
					// cnstObj = {};
					// cnsts.forEach(c => cnstObj[c.cnstKey] = c.cnstVal ? eval(`(${c.cnstVal})`) : c.cnstVal);
					// if (objFct) {
					// 	let oCnsts = objFct.get("@cnsts");
					// 	if (!oCnsts) {
					// 		oCnsts = {};
					// 		objFct.set("@cnsts", oCnsts);
					// 	}
					// 	Object.assign(oCnsts, cnstObj);
					// }
				}
				if (attrs && attrs.length > 0) {
					funStr += `return {\n`;
					retFlg = true;
					funStr += `${attrs.map(a => a.attrKey + ": " + (a.attrVal || "undefined") + ",\n").join("")}`
				}
				if (events && events.length > 0) {
					if (!retFlg) funStr += `return {\n`;
					retFlg = true;
					funStr += `${events.map(e => e.eventKey + "(" + e.eventPrm + "){\ntool.sgiLogger.info('" + belongUID + "事件集执行, 方法名为：'+ '" + e.eventKey + "');\n" + e.eventBody + "\n},\n").join("")}`
				}
				if (retFlg) {
					if (cnstFlg) funStr += `_getAllConst(){ return { ${cnsts.map(c => c.cnstKey).join(",")} }
				} \n
			} `;
					else funStr += `} `;
				} else if (cnstFlg) funStr += `return { _getAllConst() { return { ${cnsts.map(c => c.cnstKey).join(",")} } }
	}`;
				// sgiLogger.debug_1("事件集配置解析，funStr：", funStr);
				if (funStr) {
					try {
						let reg = new RegExp(/console/gi);
						funStr = funStr.replace(reg, "tool.sgiLogger");
						let $f = new Function("module", "objFct", funStr);
						let fs = $f(this, objFct);
						if (objFct) {
							// 存储事件
							let oFuns = objFct.get("@funs");
							if (!oFuns) {
								oFuns = {};
								objFct.set("@funs", oFuns);
							}
							Object.assign(oFuns, fs);
							// 存储常量
							if (cnstFlg) {
								let oCnsts = objFct.get("@cnsts");
								if (!oCnsts) {
									oCnsts = {};
									objFct.set("@cnsts", oCnsts);
								}
								Object.assign(oCnsts, fs._getAllConst());
							}
						}
						// module存储一份
						if (this.funs) Object.assign(this.funs, fs);
						else this.funs = Object.assign({}, fs);
					} catch (error) {
						sgiLogger.error("事件集配置解析出错，请检查UCV事件集配置是否正确！");
						sgiLogger.eventErr(error);
					}
				}
				// sgiLogger.timeEnd("事件集对象解析");
			}
		}
	}

	/**
   * 根据描述创建form
   * @param {父组件} parentModule
   * @param {描述} moduleDesc
   * @param {对象工厂} objFct
   * @param {make类型} type
   */
	main_mk(parentModule, moduleDesc, objFct, type) {
		//获取需要展示的数据信息
		if (!moduleDesc) {
			return;
		}
		//传入的对象工厂是否为空
		if (!objFct) {
			return;
		}

		this.state.mainUIItems = []; //再次渲染的时候清空
		//转换form公共属性
		addCtnCommonAttribute(this, moduleDesc, this.state.mainUIProps);
		//组装form表单下的控件信息
		if (type !== "dnd") this.fitMainUIItems(moduleDesc, this.state.mainUIItems, objFct, type);
	}

	/**
	 * 根据描述组装子对象
	 * @param {描述信息} moduleDesc
	 * @param {属性} formProps
	 */
	fitMainUIItems = function (moduleDesc, mainUIItems, objFct, type) {
		var me = this;

		//form下的子节点添加到form组件中
		let cldSet = moduleDesc.cldSet;
		if (cldSet && cldSet.length && cldSet.length > 0) {
			cldSet.forEach((item, index) => {
				let tmpSonComp = convertModuleByGuid(me, item, null, objFct, type);
				if (tmpSonComp) {
					mainUIItems.push(tmpSonComp);
				}
			});

		}
	}

	//render之前调用，业务逻辑都应该放在这里，如对state的操作等
	componentWillMount = function () {
		//添加页面初始化监听器
		let { moduleDesc, objFct } = this.props;
		if (!moduleDesc || !objFct) {
			return;
		}

		//追加服务列表 地址放入对象工厂 wz 2020/3/10
		//wz 追加 服务列表放入到对象工厂
		if (moduleDesc.rlsSIList) {
			moduleDesc.rlsSIList.forEach(element => {
				let copyElement = {};
				if (element.siUrl && element.siUrl.indexOf("http") < 0) {
					// element.siUrl = sgiConfig.service + "/" + element.siUrl;
					copyElement.siUrl = sgiConfig.service + "/" + element.siUrl;
					copyElement.rlsGuid = element.rlsGuid;
					// objFct.set(element.siKey, sgiConfig.service + "/" + element.siUrl);
				} else {
					copyElement.siUrl = element.siUrl;
					copyElement.rlsGuid = element.rlsGuid;
					// objFct.set(element.siKey, element.siUrl);
				}
				//服务调用的时候 去处理拆分
				objFct.set(element.siKey, copyElement);
			});
		}

		// var initLsn = moduleDesc.initLsn;// 页面初始化监听器
		// if (initLsn && this.props.type != 'dnd') {
		// 	try {
		// 		// sgiLogger.eventin('初始化');
		// 		var initFn = new Function("module", "objFct", initLsn);
		// 		tool.sgiLogger.log('初始化');
		// 		tool.sgiLogger.time("初始化[" + moduleDesc.guid + "]");
		// 		initFn(this, objFct);
		// 		tool.sgiLogger.timeEnd("初始化[" + moduleDesc.guid + "]");
		// 	} catch (error) {
		// 		sgiLogger.eventErr(error);
		// 	}
		// }
		if (this.props.type != 'dnd' && this.props.type != "dnd-nest") {
			try {


				if (moduleDesc.initLsn && typeof (moduleDesc.initLsn) == "string") {
					let reg = new RegExp(/console/gi);
					moduleDesc.initLsn = moduleDesc.initLsn.replace(reg, "tool.sgiLogger");
				}

				let initFn = getFunctionByKey(this, "initLsn") || (moduleDesc.initLsn ? new Function("module", "objFct", moduleDesc.initLsn) : null);
				if (initFn && typeof initFn == "function") {
					sgiLogger.time("初始化[" + moduleDesc.guid + "]");
					initFn(this, objFct);
					sgiLogger.timeEnd("初始化[" + moduleDesc.guid + "]");
				}
				// let initFn;
				// if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys["initLsn"]) {
				// 	// 事件集模式
				// 	// let funs = Object.assign({}, objFct.get("@funs"), this.funs);
				// 	// let key = moduleDesc.eventKeys["initLsn"];
				// 	// initFn = funs[key];
				// 	initFn = getFunctionByKey(this, "initLsn");
				// } else {
				// 	// 原事件模式
				// 	var initLsn = moduleDesc.initLsn;// 页面初始化监听器
				// 	initFn = new Function("module", "objFct", initLsn);
				// }
				// var initFn = new Function("module", "objFct", initLsn);
				// sgiLogger.eventin('初始化');
				// sgiLogger.time("初始化[" + moduleDesc.guid + "]");
				// initFn(this, objFct);
				// sgiLogger.timeEnd("初始化[" + moduleDesc.guid + "]");
			} catch (error) {
				sgiLogger.eventErr(error);
			}
		}
	}


	/**
	 * 获取最顶的真实guid
	 * 同一个guid 打开2个不同个页面，会导致对象工厂冲突
	 * 所以在同一个guid 打开2个不同页面的时候，添加@@+随机数
	 * 含有@@的guid要用 uid存储变量，不含照旧
	 * @param {*} objFct 
	 */
	getGuidSameGuidOpenSgiMain(objFct) {
		let uid = objFct.getUID();
		if (uid && uid.indexOf('@@') > 0) {
			const newGuid = uid.substr(0, uid.indexOf('@@'));
			return newGuid;
		} else {
			return uid;
		}
	}


	/**
	 * 获取注册的guid，主要区分顶级uid和嵌入弹出uid区别
	 * 同一个guid 打开2个不同个页面，会导致对象工厂冲突
	 * 所以在同一个guid 打开2个不同页面的时候，添加@@+随机数
	 * 含有@@的guid要用 uid存储变量，不含照旧
	 * @param {} objFct 
	 * @param {*} guid 
	 */
	getUIDSameGuidOpenSgiMain(guid, objFct) {
		let uid = objFct.getUID();
		if (uid && uid.indexOf('@@') > 0) {
			const newGuid = uid.substr(0, uid.indexOf('@@'));
			if (newGuid === guid) {
				return uid;
			} else {
				return guid
			}
		} else {
			return guid;
		}
	}

	//该方法发生在render方法之后。在该方法中，ReactJS会使用render生成返回的虚拟DOM对象来创建真实的DOM结构
	componentDidMount = function () {
		tool.sgiLogger.log('SgiMainCompcomponentDidMount');
		//添加页面初始化监听器
		let { moduleDesc, objFct } = this.props;
		if (!moduleDesc || !objFct) {
			return;
		}
		//将所有引用 都放入到统一Manager里面管理起来
		this.fitComponentManager(this.refs, objFct.getUID());
		//把自己放进去 将所有引用 都放入到统一Manager里面管理起来
		ComponentManager.set(objFct.getUID(), this.getUIDSameGuidOpenSgiMain(PrmFactory.makeGUID(moduleDesc), objFct), this);

		// var initAftLsn = moduleDesc.initAftLsn;// 页面加载后监听器
		// if (initAftLsn && this.props.type != 'dnd') {
		// 	try {
		// 		// sgiLogger.eventin('加载后');
		// 		var initAftLsn = new Function("module", "objFct", initAftLsn);
		// 		tool.sgiLogger.log('加载后');
		// 		tool.sgiLogger.time("加载后[" + moduleDesc.guid + "]");
		// 		initAftLsn(this, objFct);
		// 		tool.sgiLogger.timeEnd("加载后[" + moduleDesc.guid + "]");
		// 	} catch (error) {
		// 		sgiLogger.eventErr(error);
		// 	}
		// }
		if (this.props.type != 'dnd' && this.props.type != "dnd-nest") {
			try {
				if (moduleDesc.initAftLsn && typeof (moduleDesc.initAftLsn) == 'string') {
					let reg = new RegExp(/console/gi);
					moduleDesc.initAftLsn = moduleDesc.initAftLsn.replace(reg, "tool.sgiLogger");
				}
				let initAft = getFunctionByKey(this, "initAftLsn") || (moduleDesc.initAftLsn ? new Function("module", "objFct", moduleDesc.initAftLsn) : null);
				if (initAft && typeof initAft == "function") {
					sgiLogger.time("加载后[" + moduleDesc.guid + "]");
					initAft(this, objFct);
					sgiLogger.timeEnd("加载后[" + moduleDesc.guid + "]");
				}
				// 掉服务接口配置
				toCallSi(moduleDesc, objFct)
				// let initAft;
				// if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys["initAftLsn"]) {
				// 	// 事件集模式
				// 	// let funs = Object.assign({}, objFct.get("@funs"), this.funs);
				// 	// let key = moduleDesc.eventKeys["initAftLsn"];
				// 	// initAft = funs[key];
				// 	initAft = getFunctionByKey(this, "initAftLsn");
				// } else {
				// 	// 原事件模式
				// 	var initAftLsn = moduleDesc.initAftLsn;// 页面加载后监听器
				// 	initAft = new Function("module", "objFct", initAftLsn);
				// }
				// // var initAftLsn = new Function("module", "objFct", initAftLsn);
				// // sgiLogger.eventin('加载后');
				// sgiLogger.time("加载后[" + moduleDesc.guid + "]");
				// initAft(this, objFct);
				// sgiLogger.timeEnd("加载后[" + moduleDesc.guid + "]");
			} catch (error) {
				sgiLogger.eventErr(error);
			}
		}
	}

	fitComponentManager = (refs, uid) => {
		let itemRef;
		for (var itemRefKey in refs) {
			itemRef = refs[itemRefKey];
			ComponentManager.set(uid, itemRefKey, itemRef);
			if (itemRef.refs) {
				this.fitComponentManager(itemRef.refs, uid);
			}
		}
	};

	refresh() {
		this.state.loaded = false;
		this.setState({ loading: false });
	}

	removeModal() {
		this.state.modalItems.pop();
		this.state.modalInstanceItems.pop();
	}

	/**
	 * 添加展示modal 虚拟dom
	 * @param {} modal 
	 */
	addModal(modal) {
		if (!modal) {
			return;
		}
		this.state.modalItems.push(modal);
	}

	// 通过描述添加Modal
	addModalByProps(prps) {
		if (!prps) return;
		this.state.modalItems.push(<SgiModal {...prps} />);
	}

	/**
	 * 获取加载后的 组件
	 */
	getModal() {
		if (!this.state.modalInstanceItems.length) {
			return;
		}
		return this.state.modalInstanceItems[this.state.modalInstanceItems.length - 1];
	}

	/**
	 * 设置加载后的 组件
	 * 将加载后的组件信息管理起来，为了管理获取组件，操纵组件,跟addModal一起使用
	 * modal是在创建的的时候使用
	 * @param {*} modal
	 */
	setModal(modal) {
		if (!modal) {
			return;
		}
		this.state.modalInstanceItems.push(modal);
	}

	//渲染并返回一个虚拟DOM
	render = function () {

		const { parentModule, moduleDesc, objFct, type } = this.props;

		if (!this.state.loaded) {
			//组装属性
			this.main_mk(parentModule, moduleDesc, objFct, type);
			this.state.loaded = true;
		}

		// 自定义样式处理
		// const getCstmStyle = this.state.cstmStyle;
		const getCstmStyle = getFunctionByKey(this, "cstmStyle");
		let cstmStyle = {};
		if (getCstmStyle/* && type !== "dnd"*/) {
			cstmStyle = getCstmStyle(this, objFct) || {};
		}
		Object.assign(this.state.mainUIProps.style, cstmStyle);

		return (
			<div {...this.state.mainUIProps}>
				{this.state.mainUIItems}
				{this.state.modalItems}
				{this.props.children}
			</div>
		);
	}

	componentWillUnmount() {

		const { moduleDesc, objFct } = this.props;
		if (!objFct || !moduleDesc) return;

		// 销毁注册组件
		const { guid } = moduleDesc;//获取当前页面guid
		// const uid = objFct.getUID();//获取主页面uid
		const uid = this.getGuidSameGuidOpenSgiMain(objFct);//获取主页面uid
		if (guid === uid) {
			// // 关闭事件
			// var clsLsn = moduleDesc.clsLsn;// 页面加载后监听器
			// if (clsLsn && this.props.type != 'dnd') {
			// 	try {
			// 		// sgiLogger.eventin('加载后');
			// 		var clsLsn = new Function("module", "objFct", clsLsn);
			// 		tool.sgiLogger.log('关闭事件');
			// 		clsLsn(this, objFct);
			// 	} catch (error) {
			// 		sgiLogger.eventErr(error);
			// 	}
			// }
			// 关闭事件
			if (this.props.type != 'dnd' && this.props.type != "dnd-nest") {
				try {
					if (moduleDesc.clsLsn && typeof (moduleDesc.clsLsn) == 'string') {
						let reg = new RegExp(/console/gi);
						moduleDesc.clsLsn = moduleDesc.clsLsn.replace(reg, "tool.sgiLogger");
					}
					let cls = getFunctionByKey(this, "clsLsn") || (moduleDesc.clsLsn ? new Function("module", "objFct", moduleDesc.clsLsn) : null);
					if (cls && typeof cls == "function") {
						sgiLogger.debug('关闭事件');
						cls(this, objFct);
					}
					// let cls;
					// if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys["clsLsn"]) {
					// 	// 事件集模式
					// 	// let funs = Object.assign({}, objFct.get("@funs"), this.funs);
					// 	// let key = moduleDesc.eventKeys["clsLsn"];
					// 	// cls = funs[key];
					// 	cls = getFunctionByKey(this, "clsLsn");
					// } else {
					// 	// 原事件模式
					// 	var clsLsn = moduleDesc.clsLsn;// 页面加载后监听器
					// 	cls = new Function("module", "objFct", clsLsn);
					// }
					// // var clsLsn = new Function("module", "objFct", clsLsn);
					// sgiLogger.debug('关闭事件');
					// cls(this, objFct);

					//清空对象工厂
					objFct.clear();

					//清空moduleDesc
					for (const key in moduleDesc) {
						delete moduleDesc[key];
					}
				} catch (error) {
					sgiLogger.eventErr(error);
				}
			}

			// 当前页面为主页面
			//删除主页面对应所有注册组件
			ComponentManager.deleteByUid(objFct.getUID() || uid);//使用弹出窗会出现bug

		} else {
			// 当前页面为弹出窗等页面，暂时不进行处理
			// ComponentManager.deleteById(guid);

		}

	}
}

export { SgiMainComp };
export default SgiMainComp;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiMainComp.js